module.exports = __webpack_public_path__ + "static/img/oil_logo.7d63c4ae.png";